module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_modelgun_a9e1e0164eb01d1c3467654145ba5fb2.png";